import G_SELECTOR__image_line_brush from './G_SELECTOR__image_line_brush';

export function G_SIDEBAR__IMAGE_EDIT__line_draw() {
  return (
    <div className="size-full flex flex-col items-start justify-start gap-2 p-2">
      <G_SELECTOR__image_line_brush />
    </div>
  );
}
